
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manufacturing-blog",
      function () {
        return require("private-next-pages/manufacturing-blog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manufacturing-blog"])
      });
    }
  